import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Structures } from '@clavisco/core';
import ICLResponse = Structures.Interfaces.ICLResponse;

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(
    private http: HttpClient,
  ) { }

  /**
 * Fetches the spreadsheet report for a given student CardCode.
 * 
 * @param studentCardCode - The studen Cardcode for which to fetch the report.
 * @param month - The studen month for which to fetch the report.
 * @param year - The studen year for which to fetch the report.
 * @returns An observable containing the response with the report data (base64 encoded string).
 */
  GetDraftReport(studentCardCode: string, month: string, year: string): Observable<ICLResponse<string>> {
    const params = new HttpParams()
      .set('studentCardCode', studentCardCode)
      .set('month', month)
      .set('year', year);
    return this.http.get<ICLResponse<string>>(`api/Report/GetDraftReport`, { params });
  }

   /**
 * Fetches the spreadsheet report for a given student CardCode.
 * 
 * @param studentCardCode - The studen Cardcode for which to fetch the report.
 * @param month - The studen month for which to fetch the report.
 * @param year - The studen year for which to fetch the report.
 * @returns An observable containing the response with the report data (base64 encoded string).
 */
   GetInvoiceReport(studentCardCode: string, month: string, year: string): Observable<ICLResponse<string>> {
    const params = new HttpParams()
      .set('studentCardCode', studentCardCode)
      .set('month', month)
      .set('year', year);
    return this.http.get<ICLResponse<string>>(`api/Report/GetInvoiceReport`, { params });
  }

}
